<template>
    <DefaultTemplate :model="model">
        <div class="container">
            <div class="mt-12 mb-8">
                <Breadcrumbs :breadcrumbs="model.breadcrumbs" className="text-grey-400" />
            </div>
        </div>

        <div class="container" id="top">
            <h1 class="text-green-600 text-4xl font-bold mb-8">
                {{ model.name }}
            </h1>
            <div class="mb-12 md:flex md:space-x-2">
                <button
                    v-for="(region, index) in regions"
                    :key="index"
                    @click.prevent="toggleRegion(region)"
                    :class="checkIfRegionIsSet(region) ? 'bg-green-600 text-white': 'bg-gray-200 text-gray-800'"
                    class="w-full mb-4 md:w-auto rounded-sm flex py-2 px-4 hover:bg-blue-600 active:bg-red-600"
                    type="button"
                >
                    <font-awesome-icon class="fa-lg mr-2" icon="map-marker-alt" />
                    <span>
                        Region {{ region }}
                    </span>
                </button>
                <button v-if="selectedRegion.length !== 0" @click.prevent="resetRegion()" class="text-green-600 no-underline hover:text-blue-600 active:text-red-600" type="button">
                    [&nbsp;Vis alle&nbsp;]
                </button>
            </div>

            <div class="md:flex">
                <!-- List -->
                <div class="w-full md:w-3/4">
                    <div v-for="year in courses" :key="year.year">
                        <div v-for="month in year.courses" :key="month.month" :id="month.month">
                            <h2 class="text-black text-4xl font-light mb-6 border-t border-black pt-12">
                                <span class="capitalize">{{ month.month }}</span> {{ year.year }}
                            </h2>

                            <ol class="flex flex-wrap -m-2 mb-12">
                                <template v-for="(course, index) in month.courses">
                                    <course-list-element v-if="checkIfRegionIsSet(course.region)" :course="course" :key="index" :classes="'w-full sm:w-1/2 lg:w-1/3'"/>
                                </template>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- // List -->

                <!-- TOC -->
                <div class="w-full md:w-1/4 px-4 relative">
                    <div class="md:sticky md:top-0 md:pt-12">
                        <h3 class="hidden md:block mb-1 mt-0 font-semibold text-base border-b border-gray-800">Snarveier</h3>
                        <div class="mb-10">
                            <ul v-for="year in courses" :key="year.year" class="hidden md:block">
                                <li v-for="month in year.courses" :key="month.month">
                                    <button v-scroll-to="{
                                            el: `#${month.month}`,
                                            onDone: ()=>
                                        setToc(month.month)
                                        }"
                                        :title="`Hopp til ${month.month}`"
                                        :class="month.month === selectedToc ? 'font-bold' : 'font-normal'"
                                        class="capitalize hover:underline"
                                        >
                                        {{ month.month }} {{ year.year }}
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <h3 class="border-b border-gray-800 mb-2 mt-0 font-semibold text-base">Filmopptak fra konferanser</h3>
                        <a
                            v-if="model.videolink1 && model.videolinkTitle1"
                            :href="model.videolink1"
                            :title="`${model.videolinkTitle1} (åpnes i eget vindu)`"
                            class="flex group bg-gray-200 p-2 rounded text-sm leading-none block hover:bg-red-500 hover:text-white mb-2"
                            target="_blank"
                        >
                            <font-awesome-icon class="mr-2 text-red-500 group-hover:text-white" icon="play" />
                            <span>{{ model.videolinkTitle1 }}</span>
                        </a>
                        <a
                            v-if="model.videolink2 && model.videolinkTitle2"
                            :href="model.videolink2"
                            :title="`${model.videolinkTitle2} (åpnes i eget vindu)`"
                            class="flex group bg-gray-200 p-2 rounded text-sm leading-none block hover:bg-red-500 hover:text-white mb-2"
                            target="_blank"
                        >
                            <font-awesome-icon class="mr-2 text-red-500 group-hover:text-white" icon="play" />
                            <span>{{ model.videolinkTitle2 }}</span>
                        </a>
                        <a
                            v-if="model.videolink3 && model.videolinkTitle3"
                            :href="model.videolink3"
                            :title="`${model.videolinkTitle3} (åpnes i eget vindu)`"
                            class="flex group bg-gray-200 p-2 rounded text-sm leading-none block hover:bg-red-500 hover:text-white mb-2"
                            target="_blank"
                        >
                            <font-awesome-icon class="mr-2 text-red-500 group-hover:text-white" icon="play" />
                            <span>{{ model.videolinkTitle3 }}</span>
                        </a>
                        <div v-if="model.mainListRoot.value.url" class="text-right">
                            <a
                                :href="model.mainListRoot.value.url"
                                title="Se flere filmopptak"
                                class="text-green-600 hover:text-blue-600"
                            >
                                Se flere &rarr;
                            </a>
                        </div>
                    </div>
                </div>
                <!-- // TOC -->

            </div>
        </div>
    </DefaultTemplate>
</template>

<script>
import Breadcrumbs from '@/Scripts/components/organisms/Breadcrumbs/breadcrumbs.vue';
import CourseListElement from '@/Scripts/components/organisms/CourseListElement/courseListElement.vue';

export default {
    props: ['model'],
    components: {
        Breadcrumbs,
        CourseListElement
    },
    data() {
        return {
            courses: [],
            regions: ['Nord', 'Midt', 'Vest', 'Sør-øst'],
            selectedRegion: [],
            selectedToc: null
        };
    },
    methods: {
        filterPrevYear() {
            const courses = this.model.courses;
            const d = new Date();
            this.courses = courses.filter((course) => {
                return course.year > d.getFullYear() - 1;
            });
        },
        toggleRegion(region) {
            const selectedRegion = this.selectedRegion;

            if (!selectedRegion.includes(region)) {
                this.selectedRegion.push(region);
            } else {
                this.selectedRegion = selectedRegion.filter((reg) => {
                    return reg !== region ? true : false;
                });
            }
        },
        resetRegion() {
            this.selectedRegion = [];
        },
        checkIfRegionIsSet(region) {
            const selectedRegion = this.selectedRegion;
            if (region === null) {
                return true;
            }
            if (selectedRegion.length > 0) {
                return selectedRegion.includes(region);
            } else {
                return true;
            }
        },
        setToc(month) {
            this.selectedToc = month;
        },
        ifTocSelected(month) {
            return month === month.selectedToc ? true : false;
        }
    },
    mounted() {
        this.filterPrevYear();
    },
};
</script>
